import React from 'react';

interface ReadingProgressProps {
  color?: string;
}

const colorMap: Record<string, string> = {
  primary: 'bg-gradient-to-r from-primary-500 to-primary-600',
  accent: 'bg-gradient-to-r from-accent-500 to-accent-600',
  teal: 'bg-gradient-to-r from-teal-500 to-teal-600',
  blue: 'bg-gradient-to-r from-blue-500 to-blue-600',
};

export function ReadingProgress({ color = 'primary' }: ReadingProgressProps) {
  const [readingProgress, setReadingProgress] = React.useState(0);

  React.useEffect(() => {
    const calculateReadingProgress = () => {
      const element = document.documentElement;
      const totalHeight = element.scrollHeight - element.clientHeight;
      const windowScrollTop = window.scrollY || document.documentElement.scrollTop;

      if (totalHeight > 0) {
        const newProgress = (windowScrollTop / totalHeight) * 100;
        setReadingProgress(newProgress);
      }
    };

    window.addEventListener('scroll', calculateReadingProgress);
    calculateReadingProgress();

    return () => window.removeEventListener('scroll', calculateReadingProgress);
  }, []);

  return (
    <div className="fixed top-16 left-0 right-0 h-1 z-50">
      <div className="relative w-full h-full bg-gray-200 dark:bg-gray-700">
        <div
          className={`absolute top-0 left-0 h-full ${colorMap[color] || colorMap.primary} transition-all duration-200 ease-out`}
          style={{ width: `${readingProgress}%` }}
        />
      </div>
    </div>
  );
}